import { useParams, Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ArrowRight, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { fetchFormVersion } from '../api/form-builder-api'
import { FormPreviewPane } from '../components/form-preview-pane'

export function FormPreviewPage() {
  const { projectId, formId } = useParams<{ projectId: string; formId: string }>()

  const { data, isLoading } = useQuery({
    queryKey: ['form-version', formId],
    queryFn: () => fetchFormVersion(formId!),
    enabled: !!formId,
  })

  if (isLoading) {
    return (
      <div className="p-8 space-y-4">
        <div className="h-8 bg-muted rounded animate-pulse w-64" />
        <div className="h-48 bg-muted rounded-xl animate-pulse" />
      </div>
    )
  }

  if (!data) return null

  return (
    <div className="flex flex-col h-full bg-background">
      <div className="px-6 py-3 border-b border-border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <Link to={`/projects/${projectId}/form-builder`} className="hover:text-foreground">فرم‌ساز</Link>
            <ArrowRight className="w-3 h-3 rotate-180" />
            <Link to={`/projects/${projectId}/form-builder/${formId}`} className="hover:text-foreground">
              {data.formTitle}
            </Link>
            <ArrowRight className="w-3 h-3 rotate-180" />
            <span className="text-foreground">پیش‌نمایش</span>
          </div>
          <Link to={`/projects/${projectId}/form-builder/${formId}`}>
            <Button variant="ghost" size="sm" className="h-7 gap-1 text-xs">
              <X className="w-3.5 h-3.5" />
              بستن
            </Button>
          </Link>
        </div>
      </div>

      <FormPreviewPane
        definition={data.definition}
        title={data.formTitle}
        banner="حالت پیش‌نمایش — داده‌ها ذخیره نمی‌شوند، اعتبارسنجی فعال است"
        className="flex-1"
      />
    </div>
  )
}
